import { render, staticRenderFns } from "./ProAside.vue?vue&type=template&id=77602b5e&"
import script from "./ProAside.vue?vue&type=script&lang=js&"
export * from "./ProAside.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports